import React, { useEffect, useState } from "react";
import { Col, Container, Row } from "react-bootstrap";
import EventGalleryList from "./EventGalleryList";
import API from "../../config/axios";
import { api_paths } from "../../config/api.paths";

const EventDetailsPage = ({ eventId }) => {
  const [loading, setLoading] = useState(false);
  const [galleryData, setGalleryData] = useState([]);

  useEffect(() => {
    const fetchGalleryData = async () => {
      try {
        setLoading(true);

        const url = `${api_paths.member.EVENTS.EVENT_GALLERY_PAGE.GET_EVENT_IMAGES}${eventId}`;

        const response = await API.get(url);

        const data = response.data?.payload?.result?.data || [];
        console.log(data);

        setGalleryData(data);
      } catch (error) {
        console.error("Error fetching event gallery:", error);
      } finally {
        setLoading(false);
      }
    };

    fetchGalleryData();
  }, [eventId]);

  return (
    <Container className="py-5">
      <Row className="mb-4">
        <Col lg={12}>
          <div className="rsvp-header text-center">
            <h1 className="inter-bold h1">India Festival 2025</h1>
            <p>Capturing memories from our community events</p>
          </div>
        </Col>
      </Row>

      {/* {!loading && galleryData.length > 0 && (
        <EventGalleryList data={galleryData} />
      )} */}
    </Container>
  );
};

export default EventDetailsPage;
